export default __webpack_public_path__ + "media/styles/images/inbio-powered-by-ML-972ff4befce0f6400c24dc80468973aa.svg";